import './init';
import Vue from 'vue'
import App from './ui/App.vue'

new Vue(App).$mount('#app')
